import { render } from "./AddEV.vue?vue&type=template&id=f8d6b50a"
import script from "./AddEV.vue?vue&type=script&lang=js"
export * from "./AddEV.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__